import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Spinner from '../../../../components/spinner/spinner';
import { REQUEST_CUSTOM_EVENTS } from '../requestConstants';
import { REQUEST_STATUS } from '../../../../utils/constants';

const AdminActions = ({ requestDetails, setError }) => {
    const [updating, setUpdating] = useState(false);

    const openFieldExecDialog = () => {
      document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.OPEN_ASSIGN_EXEC_DIALOG, { detail: requestDetails }));
    };

    const confirmRequest = async () => {
      if (updating) return;
      try {
          setUpdating(true);
          const url = `${APIUtils.getAdminAPIEndpoint('update-request')}/${requestDetails.uniqueId}`;
          const res = await httpClient.put(url, { status: 'CONFIRMED' }).then(res => res.data);
          if (res.status === 'success') {
            Swal.fire('Request confirmed successfully!', '', 'success');
            document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.UPDATE_REQ_DETAILS, { detail: {...requestDetails, status: 'CONFIRMED'} }));
          }
      } catch (error) {
          console.error('Error confirming request:', error);
          setError(error);
          if (error?.cause?.response?.data?.message) {
              Swal.fire('Sorry!', error.cause.response.data.message, 'error');
              return;
          }
          Swal.fire('Something Went Wrong!', '', 'error');
      } finally {
          setUpdating(false);
      }
    };

    const approveBtn = () => {
      const btnText = updating ? <>Confirming Request&nbsp;<Spinner /></> : 'Confirm';
      return <Button variant="contained" onClick={confirmRequest} disabled={updating}> {btnText} </Button>;
    };

    const assignBtn = <Button variant="contained" onClick={openFieldExecDialog}> Assign Field Executive </Button>;

    const showActions = () => {
      const centerVisit = () => {
        switch (requestDetails.status) {
          case REQUEST_STATUS.PENDING:
            return approveBtn();
          default:
            return;
        }
      };

      const homeCollection = () => {
        switch (requestDetails.status) {
          case REQUEST_STATUS.PENDING:
            return assignBtn;
          default:
            return;
        }
      };

      switch (requestDetails.testServiceType) {
        case 'Center Visit':
          return centerVisit();
        case 'Home Collection':
          return homeCollection();
        default:
          return;
      }
    };

    return (
      <>
        {/* <Divider style={{marginBottom: '1rem'}} /> */}
        {/* <AssignExec /> */}
        <div style={{textAlign: 'right'}}>
          {showActions()}
        </div>
      </>
    );
  };

  export default AdminActions;

  AdminActions.propTypes = {
    requestDetails: PropTypes.object.isRequired,
    setError: PropTypes.func.isRequired,
  };